module.exports = __webpack_public_path__ + "static/media/zoomy7_preview.be2bfd0f.jpg";